/**
 * The ONE allowlist of places sign-in may return to.
 *
 * Login, select-instance, the Connect Claude guard and the 401 handler all ask
 * here. A return URL is an open-redirect vector (and one of these pages is an
 * OAuth consent screen), so this is a list of exact shapes, not "any internal
 * path": path and query only, no scheme or host, no `//`, no backslash, no
 * fragment, no whitespace. Anything else yields null and login lands on the
 * dashboard as it always has.
 *
 *   • Asana 1220202714832247 (PR #35) — the billing payment result page.
 *   • Asana 1220200369532510 — the Connect Claude page, with either the
 *     40-character request key Claude sends or the `?error=` code it sends
 *     instead. "keep the full address through select instance, login and the
 *     otp step, then come back to this page after sign in".
 *
 * The address travels as a `returnUrl` query parameter, never storage:
 * `AuthService.clearAuth()` wipes sessionStorage on every 401, which would
 * drop it exactly when it is needed.
 */

export const CONNECT_CLAUDE_PATH = '/connect/claude';

const RETURN_URL_ALLOWLIST: readonly RegExp[] = [
  /^\/billing\/payment-result(\?[^\s#\\]*)?$/,
  /^\/connect\/claude\?request=[A-Za-z0-9]{40}$/,
  /^\/connect\/claude\?error=[a-z_]{1,64}$/,
];

/** The return URL to honour, or null. */
export function safeReturnUrl(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string') return null;
  const v = raw.trim();
  return RETURN_URL_ALLOWLIST.some(re => re.test(v)) ? v : null;
}

/** `{ returnUrl }` for router query params when `url` is allowed, else `{}`. */
export function returnUrlParams(url: string | null | undefined): { returnUrl?: string } {
  const safe = safeReturnUrl(url);
  return safe ? { returnUrl: safe } : {};
}
